export default {"src":"/frontend-static/_next/static/media/applepayLight.9ef1f95b.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};